// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/uploader/api/uploader.proto (package gx.uploader.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_source_resources_file_upload_intent_file_upload_intent } from "../../source/resources/file_upload_intent/file_upload_intent_pb.js";
import { file_services_uploader_resources_uploader } from "../resources/uploader_pb.js";

/**
 * Describes the file services/uploader/api/uploader.proto.
 */
export const file_services_uploader_api_uploader = /*@__PURE__*/
  fileDesc("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", [file_services_source_resources_file_upload_intent_file_upload_intent, file_services_uploader_resources_uploader]);

/**
 * Describes the message gx.uploader.api.CreateUploadSyncRequest.
 * Use `create(CreateUploadSyncRequestSchema)` to create a new message.
 */
export const CreateUploadSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 0);

/**
 * Describes the message gx.uploader.api.CreateUploadSyncResponse.
 * Use `create(CreateUploadSyncResponseSchema)` to create a new message.
 */
export const CreateUploadSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 1);

/**
 * Describes the message gx.uploader.api.GetUploadSyncRequest.
 * Use `create(GetUploadSyncRequestSchema)` to create a new message.
 */
export const GetUploadSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 2);

/**
 * Describes the message gx.uploader.api.GetUploadSyncResponse.
 * Use `create(GetUploadSyncResponseSchema)` to create a new message.
 */
export const GetUploadSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 3);

/**
 * Describes the message gx.uploader.api.CancelUploadSyncRequest.
 * Use `create(CancelUploadSyncRequestSchema)` to create a new message.
 */
export const CancelUploadSyncRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 4);

/**
 * Describes the message gx.uploader.api.CancelUploadSyncResponse.
 * Use `create(CancelUploadSyncResponseSchema)` to create a new message.
 */
export const CancelUploadSyncResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 5);

/**
 * Describes the message gx.uploader.api.InitiateUploadRequest.
 * Use `create(InitiateUploadRequestSchema)` to create a new message.
 */
export const InitiateUploadRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 6);

/**
 * Describes the message gx.uploader.api.InitiateUploadResponse.
 * Use `create(InitiateUploadResponseSchema)` to create a new message.
 */
export const InitiateUploadResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 7);

/**
 * Describes the message gx.uploader.api.RefreshPresignedUrlsRequest.
 * Use `create(RefreshPresignedUrlsRequestSchema)` to create a new message.
 */
export const RefreshPresignedUrlsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 8);

/**
 * Describes the message gx.uploader.api.RefreshPresignedUrlsResponse.
 * Use `create(RefreshPresignedUrlsResponseSchema)` to create a new message.
 */
export const RefreshPresignedUrlsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 9);

/**
 * Describes the message gx.uploader.api.CompletePartUploadRequest.
 * Use `create(CompletePartUploadRequestSchema)` to create a new message.
 */
export const CompletePartUploadRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 10);

/**
 * Describes the message gx.uploader.api.CompletePartUploadResponse.
 * Use `create(CompletePartUploadResponseSchema)` to create a new message.
 */
export const CompletePartUploadResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 11);

/**
 * Describes the message gx.uploader.api.CompleteOperationUploadRequest.
 * Use `create(CompleteOperationUploadRequestSchema)` to create a new message.
 */
export const CompleteOperationUploadRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 12);

/**
 * Describes the message gx.uploader.api.CompleteOperationUploadResponse.
 * Use `create(CompleteOperationUploadResponseSchema)` to create a new message.
 */
export const CompleteOperationUploadResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 13);

/**
 * Describes the message gx.uploader.api.AbortOperationUploadRequest.
 * Use `create(AbortOperationUploadRequestSchema)` to create a new message.
 */
export const AbortOperationUploadRequestSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 14);

/**
 * Describes the message gx.uploader.api.AbortOperationUploadResponse.
 * Use `create(AbortOperationUploadResponseSchema)` to create a new message.
 */
export const AbortOperationUploadResponseSchema = /*@__PURE__*/
  messageDesc(file_services_uploader_api_uploader, 15);

/**
 * @generated from service gx.uploader.api.UploadService
 */
export const UploadService = /*@__PURE__*/
  serviceDesc(file_services_uploader_api_uploader, 0);

